import { Button, Col, Form, Row } from "react-bootstrap";

    const VendorForm = ({handleChange,handleClear,handleSubmit,formData,selectedVendor}) => {

 
 
      return (
        <>
          <Form onSubmit={handleSubmit}>
            <Row className="">
              <Col md={4} className="mb-2">
                <Form.Group>
                  <Form.Label>{"Name"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.name}
                    name="name"
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4} className=" mb-2">
                <Form.Group>
                  <Form.Label>{"Address1"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.address1}
                    name="address1"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-2">
                <Form.Group>
                  <Form.Label>{"Address2"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.address2}
                    name="address2"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-2">
                <Form.Group>
                  <Form.Label>{"State"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.address3}
                    name="address3"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-2">
                <Form.Group>
                  <Form.Label>{"Pin code"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.address4}
                    name="address4"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-2">
                <Form.Group>
                  <Form.Label>{"contactNumbers"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.contactNumbers}
                    name="contactNumbers"
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              {/* <Col md={4} className="mb-2">
                <Form.Group>
                  <Form.Label>{"CreatedBy"}</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.createdBy}
                    name="createdBy"
                    onChange={handleChange}
                    disabled
                  />
                </Form.Group>
              </Col> */}
              <Col md={4} className="mb-2">
                {selectedVendor &&(
                  <Form.Group>
                  <Form.Label>{"Status"}</Form.Label>
                  <Form.Select
                    value={formData.status?.toLowerCase()}
                    name="status"
                    onChange={handleChange}
                  >
                    <option value="select options"> select Options</option>
                    <option value="active">Active</option>
                    <option value="in active">In Active</option>
                  </Form.Select>
                </Form.Group>
                )}
              </Col>
            </Row>
            <div className="d-flex justify-content-end">
              <Button
                type="button"
                className=" custom-btn me-2"
                onClick={() => handleClear()}
              >
                clear
              </Button>
              <Button type="submit" className=".custom-btn1 ">
                {selectedVendor !== null ? "update" : "Submit"}
              </Button>
            </div>
          </Form>
        </>
      );
    };

    export default VendorForm;
